module.exports = __webpack_public_path__ + "img/logo10.85d19290.png";